export default {
  FETCH_PLANO: 'FETCH_PLANO',
  FETCH_PLANO_SUCCESS: 'FETCH_PLANO_SUCCESS',
  VACIAR_PLANO: 'VACIAR_PLANO'
}